function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0807 54.6202C45.0882 52.4393 55 41.1271 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 41.5123 10.48 53.0768 24.0294 54.7831L28.0002 60.6567L32.0807 54.6202Z"
})), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0807 54.6202C45.0882 52.4393 55 41.1271 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 41.5123 10.48 53.0768 24.0294 54.7831L28.0002 60.6567L32.0807 54.6202Z",
  fill: "#000037"
}), React.createElement("path", {
  d: "M32.0807 54.6202L31.9154 53.634L31.4924 53.7049L31.2523 54.0602L32.0807 54.6202ZM24.0294 54.7831L24.8579 54.223L24.604 53.8476L24.1543 53.7909L24.0294 54.7831ZM28.0002 60.6567L27.1717 61.2167L28.0002 62.4422L28.8286 61.2167L28.0002 60.6567ZM54 27.5C54 40.6306 44.4491 51.5325 31.9154 53.634L32.2461 55.6064C45.7273 53.3461 56 41.6237 56 27.5H54ZM27.5 1C42.1355 1 54 12.8645 54 27.5H56C56 11.7599 43.2401 -1 27.5 -1V1ZM1 27.5C1 12.8645 12.8645 1 27.5 1V-1C11.7599 -1 -1 11.7599 -1 27.5H1ZM24.1543 53.7909C11.0987 52.1468 1 41.002 1 27.5H-1C-1 42.0226 9.86132 54.0068 23.9045 55.7753L24.1543 53.7909ZM28.8286 60.0966L24.8579 54.223L23.201 55.3432L27.1717 61.2167L28.8286 60.0966ZM31.2523 54.0602L27.1717 60.0966L28.8286 61.2167L32.9092 55.1802L31.2523 54.0602Z",
  fill: "#000037",
  mask: "url(#path-1-inside-1)"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 55,
  height: 60.6567,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 55,
    height: 61,
    viewBox: "0 0 55 61",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/map-marker.459879d5.svg";
export { SvgComponent as ReactComponent };